
import Trash from "../../../assets/outline/Trash.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function TrashIcon({ className, dataTestid = "TrashIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Trash data-testid={dataTestid} className={classes} {...rest} />
  );
}
